
import * as _ from 'lodash'
import {IExportOptions, IExportService} from "./PA.Export.IF";
import {IMetricParameterSet} from "../PA.Metric.Services/PA.Metrics.IF";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import axios from "axios";
import {BehaviorSubject} from "rxjs";
import {PAMetricUtils} from "../PA.Metric.Services/PAMetricUtils";

export class PAExport implements IExportService{

    private _OnExportCompleted: BehaviorSubject<IExportService>;

    constructor() {
        this._OnExportCompleted = new BehaviorSubject<IExportService>(this);
    }

    get OnExportCompleted(): BehaviorSubject<IExportService>{
        return this._OnExportCompleted;
    }

    exportJSON(json: any, aExportOptions: IExportOptions): Promise<number> {
        const self = this;

        return new Promise<number>((resolve, reject) => {

            let aRequest = {
                method: "exportJSON",
                exportOptions: aExportOptions,
                json: json
            };

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base,"/"));
            if(sEndPoint.endsWith('/'))
                sEndPoint += 'export';
            else
                sEndPoint += '/export';

            axios.post(sEndPoint, {data: {request: aRequest}})
                .then((resp: any) => {
                    var responseData = resp.data;
                    debugger;

                    if (_.isNumber(responseData)){

                        self._OnExportCompleted.next(self);
                        resolve(_.toNumber(responseData));
                    } else{
                        reject("Unable to parse return value; unexpected type");
                    }
                })
                .catch((err:any) => {
                    reject('Unable to export file on server. ' + err);
                });
        })
    }

    exportMetrics(aMetricParamSet: IMetricParameterSet, aExportOptions: IExportOptions): Promise<number> {
        const self = this;

        return new Promise<number>((resolve, reject) => {

            PAMetricUtils.staticMetricParameterSet_preProcess(aMetricParamSet).then(() => {
                let aRequest = {
                    method: "exportMetrics",
                    exportOptions: aExportOptions,
                    metricParamSet: aMetricParamSet
                };

                let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base,"/"));
                if(sEndPoint.endsWith('/'))
                    sEndPoint += 'export';
                else
                    sEndPoint += '/export';

                axios.post(sEndPoint, {data: {request: aRequest}})
                    .then((resp: any) => {
                        var responseData = resp.data;

                        if (_.isNumber(responseData)){

                            self._OnExportCompleted.next(self);
                            resolve(_.toNumber(responseData));
                        } else{
                            reject("Unable to parse return value; unexpected type");
                        }
                    })
                    .catch((err:any) => {
                        reject('Unable to export file on server. ' + err);
                    });
            })
            .catch((err:any) => {
                reject('Unable to obtain Metric Results from Server during export. ' + err);
            });


        })
    }

    exportSnapshotDetails(aExportOptions: IExportOptions): Promise<number> {
        const self = this;

        return new Promise<number>((resolve, reject) => {

            let aRequest = {
                method: "exportSnapshotDetails",
                exportOptions: aExportOptions
            };

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base,"/"));
            if(sEndPoint.endsWith('/'))
                sEndPoint += 'export';
            else
                sEndPoint += '/export';

            axios.post(sEndPoint, {data: {request: aRequest}})
                .then((resp: any) => {
                    var responseData = resp.data;
                    debugger;

                    if (_.isNumber(responseData)){

                        self._OnExportCompleted.next(self);
                        resolve(_.toNumber(responseData));
                    } else{
                        reject("Unable to parse return value; unexpected type");
                    }
                })
                .catch((err:any) => {
                    reject('Unable to export file on server. ' + err);
                });
        })
    }

}

export class ExportOptions implements IExportOptions {

    [id: string]: IExportOptions;

    static parseJSON(srcObject: any) : IExportOptions{
        let exportOptions = new ExportOptions();

        for (var key in exportOptions){
            var bKeyExists = key in srcObject;
            if (bKeyExists){
                var srcValue = srcObject[key];

                switch(key){
                    case 'sDetailAttributes':
                    //do something for the detailAttributes
                    default:
                        exportOptions[key] = srcValue;
                }
            }
        }

        return exportOptions;
    }

}